import { createRouter, createWebHistory } from 'vue-router'
//import Home from '../views/Home.vue'
import MatchLoadouts from '../views/MatchLoadouts.vue'

const routes = [
  {
    path: '/',
    name: 'MatchLoadouts',
    component: MatchLoadouts
  },
  //{
  //  path: '/matchLoadouts',
  //  name: 'MatchLoadouts',
  //  component: MatchLoadouts
  //},
  {
    path: '/github',
    redirect: 'https://github.com/scottjsh/ValoAssist'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
